import {useEffect} from 'hooks'

export default function usePageTitle(title) {
	useEffect(() => {
		document.title = `VdS Webshop - ${title}`
	})
}